import { createApp } from 'vue';
import router from './router';
import store from './store';
import App from './App.vue';
import AddButton from './components/base/AddButton.vue';
import BaseButton from './components/base/BaseButton.vue';
import BaseGoogle from './components/base/BaseGoogle.vue';
import BaseInput from './components/base/BaseInput.vue';
import CategoryBanner from './components/base/CategoryBanner.vue';
import StoreButton from './components/base/StoreButton.vue';
import LoadingPage from './components/LoadingPage.vue';
import BaseProduct from './components/base/BaseProduct.vue';
import ElementPlus from 'element-plus';
import breadcrumbs from 'vue-3-breadcrumbs';
import BaseInfo from './components/base/BaseInfo.vue';
import './assets/styles.css';
import 'element-plus/dist/index.css';
import './AOSsettings.js';
import 'leaflet/dist/leaflet.css';


const app = createApp(App);

app.use(router);
app.use(store);
app.use(ElementPlus);
app.use(breadcrumbs, {
    useDefaultCss:true,
})

app.component('add-button', AddButton);
app.component('base-button', BaseButton);
app.component('base-google', BaseGoogle);
app.component('base-input', BaseInput);
app.component('category-banner', CategoryBanner);
app.component('store-button', StoreButton);
app.component('loading-page', LoadingPage);
app.component('base-product', BaseProduct);
app.component('base-info', BaseInfo);

app.mount('#app');

